import utils from '@/app/utils/gfUtils';
import HELPER from '@/app/utils/HELPER';

(function (jQuery) {
  jQuery.gfInputField = function (element, options) {
    const defaults = {
      textarea: false,
      addHistory: true,
      delayTyping: 10,
      onValueChanged: function (value) {},
      onHistoryAdded: function () {},
    };

    const _dataValue = [];

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;
    let _unit;

    let _unitList = [];
    let _value;
    let $targetElement;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();
      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      $targetElement = $gryffBody.find('#' + merId);

      _this.setTemplate();

      $element.on('value-change', function () {
        let value = jQuery(this).attr('value');
        if ($element.attr('unit') != undefined) {
          value = HELPER.convertToValueAndUnit(value);
          _this.setCurrentUnit(value.unit);
          _this.setValue(value.value);
        } else {
          _this.setValue(value);
        }
      });

      return false;
    };

    this.setTemplate = function () {
      _unit = typeof $element.attr('unit') === 'undefined' ? '' : $element.attr('unit');
      const unitList = typeof $element.attr('data-unit') === 'undefined' ? '' : $element.attr('data-unit');
      if (unitList !== '') {
        _unitList = unitList.split(',');
      }

      let readOnly = typeof $element.attr('readonly') === 'undefined' ? 'false' : $element.attr('readonly');
      if (readOnly == 'false') {
        readOnly = '';
      } else {
        readOnly = 'readonly="' + readOnly + '"';
      }

      const desc = typeof $element.attr('data-description') === 'undefined' ? '' : $element.attr('data-description');
      const title = typeof _this.settings.title === 'undefined' ? '' : _this.settings.title;

      const placeholder = typeof $element.attr('placeholder') === 'undefined' ? '' : $element.attr('placeholder');

      let _template = '<div class="gfInputField" data-name="' + $element.attr('name') + '">';
      _template += '<div class="gfSGSubTitle">' + title + '</div>';
      _template += '<div class="gfSGclear"></div>';
      // _template += utils.svgIcon('margin-top')
      _template += '<div class="gfInputFieldBox">';
      if (_this.settings.textarea) {
        const disabled = _this.settings.disabled ? 'disabled': '';
        _template += '<textarea type="text" placeholder="' + placeholder + '" ' + readOnly + ' '+ disabled +'></textarea>';
      } else {
        _template +=
          '<input type="text" class="gf_remove-spin-button" placeholder="' + placeholder + '" ' + readOnly + ' />';
      }
      if (_unit == '') {
        _template += '<div class="gfInputFieldUnit" data-unit="none"></div>';
      } else {
        if (unitList !== '') {
          _template += '<div class="gfInputFieldUnit">' + _unit + '</div>';
          _template += '<ul class="gfInputFieldUnitList">';
          for (let i = 0; i < _unitList.length; i++) {
            _template += '<li>' + _unitList[i] + '</li>';
          }
          _template += '</ul>';
        } else {
          // _template += '<div class="gfInputFieldUnit" data-unit="one">'+_unit+'</div>';
        }
      }
      _template += '</div>';
      _template += '<div class="gfDesc">' + desc + '</div>';
      _template += '</div>';

      $element.after(_template);

      // Set value init
      let valueInit = $element.attr('value');
      if (!valueInit) {
        valueInit = $element.attr('default_value');
      }
      if ($element.attr('unit')) {
        valueInit = HELPER.convertToValueAndUnit(valueInit);
        _this.setCurrentUnit(valueInit.unit);

        _this.setValue(valueInit.value);
      } else {
        _this.setValue(valueInit);
      }

      // Is Read Only. Stop input fields;
      if (readOnly && readOnly == 'true') {
        return false;
      }

      // apply events
      const $gfInputFieldBox = $element.next('.gfInputField');
      const $list = $gfInputFieldBox.find('.gfInputFieldUnitList');

      if ($element.attr('data-auto')) {
        $gfInputFieldBox.find('input,textarea').attr('readonly', 'true');
      }

      if (!$element.attr('data-hideUnit')) {
        $gfInputFieldBox
          .find('.gfInputFieldUnit')
          .off('click')
          .on('click', function (e) {
            if ($list.hasClass('active')) {
              $list.removeClass('active');
            } else {
              $gfLeftSideBar.find('.columns .gfInputFieldUnitList').removeClass('active');
              $list.addClass('active');
              $gfLeftSideBar.off('mousedown.u').on('mousedown.u', function (e) {
                const $target = jQuery(e.target);
                if (
                  $target.closest('.gfInputFieldUnitList').length == 0 &&
                  $target.closest('.gfInputFieldUnit').length == 0
                ) {
                  $list.removeClass('active');
                  $gfLeftSideBar.off('mousedown.u');
                }
              });
            }
          });
      }

      // HISTORY OPTIMIZE
      let merOldBackupSettings;
      let merOldBackupDesignOptions;

      $gfInputFieldBox.find('input').on('focus.inputfield', function () {
        const $this = jQuery(this);
        _isHistoryEditing = true;
        const oldValue = $element.attr('value');
        const currentTab = $gfLeftSideBar.find('.simple-tabs').data('gftabs').getCurrentTab();
        switch (currentTab) {
          case 'Settings':
            setTimeout(function () {
              merOldBackupSettings = $gryffEditor.data('gfhistory').setMERBackupSettings();
            }, 51);
            $gryffBody.off('mousedown.history.inputfield').on('mousedown.history.inputfield', function (e) {
              const $target = jQuery(e.target);

              if (!$target.is($this)) {
                if (oldValue != $element.attr('value')) {
                  const extra = {
                    flagBKSettings: true,
                  };
                  _this.settings.onHistoryAdded();
                  if (_this.settings.addHistory) {
                    $element.trigger('history-change', extra);
                  }
                }
                _isHistoryEditing = false;
                $gryffBody.off('mousedown.history.inputfield');
                jQuery('body').off('mousedown.history.inputfield');
                $gfInputFieldBox.find('input').off('focusout.history.inputfield');
              }
            });

            jQuery('body')
              .off('mousedown.history.inputfield')
              .on('mousedown.history.inputfield', function (e) {
                const $target = jQuery(e.target);

                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKSettings: true,
                    };
                    _this.settings.onHistoryAdded();
                    if (_this.settings.addHistory) {
                      $element.trigger('history-change', extra);
                    }
                  }
                  _isHistoryEditing = false;
                  $gryffBody.off('mousedown.history.inputfield');
                  jQuery('body').off('mousedown.history.inputfield');
                  $gfInputFieldBox.find('input').off('focusout.history.inputfield');
                }
              });

            $gfInputFieldBox
              .find('input')
              .off('focusout.history.inputfield')
              .on('focusout.history.inputfield', function (e) {
                const $target = jQuery(e.target);
                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKSettings: true,
                    };
                    _this.settings.onHistoryAdded();
                    if (_this.settings.addHistory) {
                      $element.trigger('history-change', extra);
                    }
                  }
                  _isHistoryEditing = false;
                  $gryffBody.off('mousedown.history.inputfield');
                  jQuery('body').off('mousedown.history.inputfield');
                  $gfInputFieldBox.find('input').off('focusout.history.inputfield');
                }
              });

            break;

          case 'Design':
            setTimeout(function () {
              merOldBackupDesignOptions = $gryffEditor.data('gfhistory').setMERBackupDesignOptions();
            }, 51);

            $gryffBody.off('mousedown.history.inputfield').on('mousedown.history.inputfield', function (e) {
              const $target = jQuery(e.target);

              if (!$target.is($this)) {
                if (oldValue != $element.attr('value')) {
                  const extra = {
                    flagBKDesignOptions: true,
                  };
                  _this.settings.onHistoryAdded();
                  if (_this.settings.addHistory) {
                    $element.trigger('history-change', extra);
                  }
                }
                _isHistoryEditing = false;
                $gryffBody.off('mousedown.history.inputfield');
                jQuery('body').off('mousedown.history.inputfield');
                $gfInputFieldBox.find('input').off('focusout.history.inputfield');
              }
            });

            jQuery('body')
              .off('mousedown.history.inputfield')
              .on('mousedown.history.inputfield', function (e) {
                const $target = jQuery(e.target);

                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKDesignOptions: true,
                    };
                    _this.settings.onHistoryAdded();
                    $element.trigger('history-change', extra);
                  }
                  _isHistoryEditing = false;
                  $gryffBody.off('mousedown.history.inputfield');
                  jQuery('body').off('mousedown.history.inputfield');
                  $gfInputFieldBox.find('input').off('focusout.history.inputfield');
                }
              });

            $gfInputFieldBox
              .find('input')
              .off('focusout.history.inputfield')
              .on('focusout.history.inputfield', function (e) {
                if (oldValue != $element.attr('value')) {
                  const extra = {
                    flagBKDesignOptions: true,
                  };
                  _this.settings.onHistoryAdded();
                  $element.trigger('history-change', extra);
                }
                _isHistoryEditing = false;
                $gryffBody.off('mousedown.history.inputfield');
                jQuery('body').off('mousedown.history.inputfield');
                $gfInputFieldBox.find('input').off('focusout.history.inputfield');
              });

            break;
        }
      });

      let delayType;
      if ($element.attr('unit')) {
        $gfInputFieldBox
          .find('input')
          .off('keyup change paste')
          .on('keyup change paste', function () {
            clearTimeout(delayType);

            const $that = jQuery(this);
            delayType = setTimeout(function () {
              let value = $that.val();
              if (value.indexOf('px') >= 0 && _unitList.indexOf('px') >= 0) {
                _this.setCurrentUnit('px');
                value = value.replace('px', '');
              } else if (value.indexOf('%') >= 0 && _unitList.indexOf('%') >= 0) {
                _this.setCurrentUnit('%');
                value = value.replace('%', '');
              }
              _this.onChangeValue(value);
              _this.settings.onValueChanged(value);
              $element.trigger('input-change');
            }, 100);
          });
        // On key down;
        // Recommit
        $gfInputFieldBox
          .find('input')
          .off('keydown.upDown')
          .on('keydown.upDown', function (e) {
            const $that = $(this);
            const old = parseInt($that.val()) || 0;

            const keyUp = 38;
            const keyDown = 40;
            if (e.which == keyUp) {
              if (e.shiftKey) {
                var newVar = old + 10;
              } else {
                var newVar = old + 1;
              }

              if ($element.hasClass('gf_padding') && newVar < 0) {
                newVar = '0';
              }

              _this.onChangeValue(newVar);
              _this.settings.onValueChanged(newVar);
              $element.trigger('input-change');
            } else if (e.which == keyDown) {
              if (e.shiftKey) {
                var newVar = old - 10;
              } else {
                var newVar = old - 1;
              }

              if ($element.hasClass('gf_padding') && newVar < 0) {
                newVar = '0';
              }

              _this.onChangeValue(newVar);
              _this.settings.onValueChanged(newVar);
              $element.trigger('input-change');
            }
          });
      } else {
        $gfInputFieldBox
          .find('input')
          .off('keyup change paste')
          .on('keyup change paste', function () {
            clearTimeout(delayType);
            const $that = jQuery(this);
            delayType = setTimeout(function () {
              const value = $that.val();
              $element.attr('value', value).val(value);
              $element.trigger('input-change');
              _this.settings.onValueChanged(value);
            }, _this.settings.delayTyping);
          });
      }

      $gfInputFieldBox.find('textarea').on('focus.inputfield', function () {
        const $this = jQuery(this);
        _isHistoryEditing = true;
        const oldValue = $element.attr('value');
        const currentTab = $gfLeftSideBar.find('.simple-tabs').data('gftabs').getCurrentTab();
        switch (currentTab) {
          case 'Settings':
            setTimeout(function () {
              merOldBackupSettings = $gryffEditor.data('gfhistory').setMERBackupSettings();
            }, 51);
            $gryffBody.off('mousedown.history.inputfield').on('mousedown.history.inputfield', function (e) {
              const $target = jQuery(e.target);

              if (!$target.is($this)) {
                if (oldValue != $element.attr('value')) {
                  const extra = {
                    flagBKSettings: true,
                  };
                  _this.settings.onHistoryAdded();
                  if (_this.settings.addHistory) {
                    $element.trigger('history-change', extra);
                  }
                }
                _isHistoryEditing = false;
                $gryffBody.off('mousedown.history.inputfield');
                jQuery('body').off('mousedown.history.inputfield');
                $gfInputFieldBox.find('input').off('focusout.history.inputfield');
              }
            });

            jQuery('body')
              .off('mousedown.history.inputfield')
              .on('mousedown.history.inputfield', function (e) {
                const $target = jQuery(e.target);

                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKSettings: true,
                    };
                    _this.settings.onHistoryAdded();
                    if (_this.settings.addHistory) {
                      $element.trigger('history-change', extra);
                    }
                  }
                  _isHistoryEditing = false;
                  $gryffBody.off('mousedown.history.inputfield');
                  jQuery('body').off('mousedown.history.inputfield');
                  $gfInputFieldBox.find('input').off('focusout.history.inputfield');
                }
              });

            $gfInputFieldBox
              .find('textarea')
              .off('focusout.history.inputfield')
              .on('focusout.history.inputfield', function (e) {
                const $target = jQuery(e.target);
                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKSettings: true,
                    };
                    _this.settings.onHistoryAdded();
                    if (_this.settings.addHistory) {
                      $element.trigger('history-change', extra);
                    }
                  }
                  _isHistoryEditing = false;
                  $gryffBody.off('mousedown.history.inputfield');
                  jQuery('body').off('mousedown.history.inputfield');
                  $gfInputFieldBox.find('textarea').off('focusout.history.inputfield');
                }
              });
            break;

          case 'Design':
            setTimeout(function () {
              merOldBackupDesignOptions = $gryffEditor.data('gfhistory').setMERBackupDesignOptions();
            }, 51);

            $gryffBody.off('mousedown.history.inputfield').on('mousedown.history.inputfield', function (e) {
              const $target = jQuery(e.target);

              if (!$target.is($this)) {
                if (oldValue != $element.attr('value')) {
                  const extra = {
                    flagBKDesignOptions: true,
                  };
                  _this.settings.onHistoryAdded();
                  if (_this.settings.addHistory) {
                    $element.trigger('history-change', extra);
                  }
                }
                _isHistoryEditing = false;
                $gryffBody.off('mousedown.history.inputfield');
                jQuery('body').off('mousedown.history.inputfield');
                $gfInputFieldBox.find('input').off('focusout.history.inputfield');
              }
            });

            jQuery('body')
              .off('mousedown.history.inputfield')
              .on('mousedown.history.inputfield', function (e) {
                const $target = jQuery(e.target);

                if (!$target.is($this)) {
                  if (oldValue != $element.attr('value')) {
                    const extra = {
                      flagBKDesignOptions: true,
                    };
                    _this.settings.onHistoryAdded();
                    if (_this.settings.addHistory) {
                      $element.trigger('history-change', extra);
                    }
                  }
                  _isHistoryEditing = false;
                  $gryffBody.off('mousedown.history.inputfield');
                  jQuery('body').off('mousedown.history.inputfield');
                  $gfInputFieldBox.find('input').off('focusout.history.inputfield');
                }
              });

            $gfInputFieldBox
              .find('textarea')
              .off('focusout.history.inputfield')
              .on('focusout.history.inputfield', function (e) {
                if (oldValue != $element.attr('value')) {
                  const extra = {
                    flagBKDesignOptions: true,
                  };
                  _this.settings.onHistoryAdded();
                  if (_this.settings.addHistory) {
                    $element.trigger('history-change', extra);
                  }
                }
                _isHistoryEditing = false;
                $gryffBody.off('mousedown.history.inputfield');
                jQuery('body').off('mousedown.history.inputfield');
                $gfInputFieldBox.find('textarea').off('focusout.history.inputfield');
              });

            break;
        }
      });

      $gfInputFieldBox
        .find('textarea')
        .off('keyup change paste')
        .on('keyup change paste', function () {
          clearTimeout(delayType);

          const $that = jQuery(this);
          delayType = setTimeout(function () {
            const value = $that.val();
            $element.attr('value', value).val(value);

            $element.trigger('input-change');
            _this.settings.onValueChanged(value);
          }, 100);
        });

      $list
        .find('li')
        .off('click')
        .on('click', function () {
          const text = $(this).text();
          if (_unit != text) {
            _value = Math.round(_this.convertUnit(text, _value) * 100) / 100;
          }
          if (text == 'auto') {
            _unit = '-';
            $gfInputFieldBox.find('.gfInputFieldUnit').text('-');
            _this.setValue('');
            $element.val('auto');
          } else {
            _this.setCurrentUnit(text);
          }

          //
          if (_value && _value !== 'auto' && _value !== '-') {
            _this.onChangeValue(_value);
          }
          _this.settings.onHistoryAdded();
          $element.trigger('input-change');
          if (_this.settings.addHistory) {
            $element.trigger('history-change');
          }
          _this.settings.onValueChanged(_value);

          $list.removeClass('active');
        });
    };

    this.getCurrentUnit = function () {
      return _unit;
    };

    this.convertUnit = function (type, value) {
      if (type == undefined) {
        type = '';
      }
      // Cover px to % and % to px;
      if ($element.attr('name') == 'width') {
        var maximum = $targetElement.width();
      } else if ($element.attr('name') == 'height') {
        var maximum = $targetElement.height();
      }
      if (type == 'px') {
        if (value > 100) {
          value = 100;
        }
        return (value * maximum) / 100;
      } else if (type == '%') {
        let ui = (value * 100) / maximum;
        if (ui > 100) {
          ui = 100;
        }
        return ui;
      } else {
        return value;
      }
    };

    this.setCurrentUnit = function (unit) {
      if ($element.attr('unit') && unit != null) {
        if (unit == false) {
          unit = $element.attr('unit');
        } else {
          $element.attr('unit', unit);
        }
        _unit = unit;

        const $gfInputFieldBox = $element.next('.gfInputField');
        $gfInputFieldBox.find('.gfInputFieldUnit').text(unit);
      }
      return false;
    };

    this.onChangeValue = function (value) {
      _value = value;

      const $gfInputFieldBox = $element.next('.gfInputField');
      if (value == 'auto' || value == '') {
        // No data
        $gfInputFieldBox.find('input').val(value);
        $element.attr('value', value).val(value);

        if ($element.attr('unit')) {
          // _this.setCurrentUnit(null);
          _unit = '-';
          $gfInputFieldBox.find('.gfInputFieldUnit').text('-');
        }
      } else {
        const inputUnit = $element.attr('unit');
        // Input unit
        if (inputUnit) {
          _unit = inputUnit;
          $gfInputFieldBox.find('.gfInputFieldUnit').text(inputUnit);

          // Update float output
          if (!isNaN(parseFloat(value))) {
            value = parseFloat(value);
          }

          const valueArr = value.toString().split('.');
          if (valueArr.length > 1) {
            value = valueArr[0] + '.' + valueArr[1].substring(0, 2);
          }

          $gfInputFieldBox.find('input').val(value);
          $element.attr('value', value + inputUnit).val(value + inputUnit);
        } else {
          $gfInputFieldBox.find('input').val(value);
          $gfInputFieldBox.find('textarea').val(value);
          $element.attr('value', value).val(value);
        }
      }

      return false;
    };

    this.setValue = function (value) {
      _this.onChangeValue(value);
      return false;
    };
    this.init();
  };
  jQuery.fn.gfInputField = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfinputfield')) {
        const plugin = new jQuery.gfInputField(this, options);
        jQuery(this).data('gfinputfield', plugin);
      }
    });
  };
})(jQuery);
